import React, { useContext, useState } from 'react'
import styles from "./newService.module.css";
import FormInput from '../../../input';
import Button from '../../../button';
import { notify } from '../../../toast';
import { CreateNewService } from '../../../../utils/services';
import { AuthContext } from '../../../../contextAPI';

const NewService = (props) => {

    const Auth = useContext(AuthContext);
    const token = Auth.isLoggedIn ? Auth.authenticatedUser.token.access_token : null

    const [name, setName] = useState("")
    const [duration, setDuration] = useState("")
    const [price, setPrice] = useState("")
    const [nameValid, setNameValid] = useState(true)
    const [durationValid, setDurationValid] = useState(true)
    const [priceValid, setPriceValid] = useState(true)

    const onSubmitHandler = async() => {
        if(!token)return notify("Prisijunkite kaip administratorius")
        if(!name)setNameValid(false)
            else setNameValid(true)

        if(!duration)setDurationValid(false)
            else setDurationValid(true)

        if(!price)setPriceValid(false)
            else setPriceValid(true)

        if(duration < 1 || price < 0)notify("Reikšmės negali būti neigiamos", "warning")

        if(name && duration > 0 && price >= 0){

            try {

                const response = await CreateNewService({
                    service_name: name,
                    service_duration: duration,
                    service_price: price,
                    project_id: process.env.REACT_APP_PROJECT_ID,
                },token)

                if(!response.status)throw new Error(response.message)

                return props.onRefreshServices(response.data.services)
            } catch (error) {
                notify(error.message || "Negalimas veiksmas", "error")
            }
        }

        return 
    }


    return (
        <div className={styles.container}>

            <div className={styles.form}>
                <FormInput 
                    onChange={(text)=>{setName(text)}}
                    isValid={nameValid}
                    name="Paslauga"
                    value={name}
                />
                <FormInput 
                    onChange={(text)=>{setDuration(text)}}
                    isValid={durationValid}
                    type={"number"}
                    name="Trukmė (min)"
                    value={duration}
                />
                <FormInput 
                    onChange={(text)=>{setPrice(text)}}
                    type="number"
                    isValid={priceValid}
                    name="Kaina (eur)"
                    value={price}
                />
            </div>

            <div className={styles.footer}>
                <Button onClick={onSubmitHandler}>
                    Pridėti
                </Button>
            </div>

        </div>
    )
}

export default NewService